import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const ArrowRightShortIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="arrowRightShort" ref={ref as any} {...props}>
      <path
        d="M14.1506 16.2232C13.8666 16.5122 13.4061 16.5122 13.1221 16.2232C12.8381 15.9341 12.8381 15.4654 13.1221 15.1763L15.517 12.7386H6.72727C6.32562 12.7386 6 12.4072 6 11.9984C6 11.5896 6.32562 11.2581 6.72727 11.2581H15.517L13.1222 8.8205C12.8381 8.53145 12.8381 8.06272 13.1222 7.77362C13.2641 7.62912 13.4502 7.55682 13.6364 7.55682C13.8225 7.55682 14.0086 7.62912 14.1506 7.77367L17.787 11.475C18.071 11.764 18.071 12.2328 17.787 12.5219L14.1506 16.2232Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
